/**
 * Euro amounts are shown in French formatting across the app: space-grouped
 * thousands and a trailing symbol ("1 234,56 €").
 */
const EUROS_FORMATTER = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
});

/** Same, without cents — used where the decimals are noise (KPIs, estimates). */
const WHOLE_EUROS_FORMATTER = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

/**
 * Formats an amount in euros, cents included.
 *
 * @param amount - the amount in euros
 * @returns the formatted amount, e.g. `1 234,56 €`
 */
export const formatEuros = (amount: number): string =>
  EUROS_FORMATTER.format(amount);

/**
 * Formats an amount in euros rounded to the nearest euro, for figures where
 * cents carry no meaning (estimated revenue, KPI tiles).
 *
 * @param amount - the amount in euros
 * @returns the formatted amount, e.g. `1 235 €`
 */
export const formatWholeEuros = (amount: number): string =>
  WHOLE_EUROS_FORMATTER.format(amount);
